/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePrefilledEmailRequestDTO
 */
export interface CreatePrefilledEmailRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof CreatePrefilledEmailRequestDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefilledEmailRequestDTO
     */
    to?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefilledEmailRequestDTO
     */
    cc?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefilledEmailRequestDTO
     */
    bcc?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefilledEmailRequestDTO
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefilledEmailRequestDTO
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePrefilledEmailRequestDTO
     */
    addMessage?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePrefilledEmailRequestDTO
     */
    priority?: number;
    /**
     * Whether this is a custom reply template.
     * @type {boolean}
     * @memberof CreatePrefilledEmailRequestDTO
     */
    isCustom?: boolean;
}

export function CreatePrefilledEmailRequestDTOFromJSON(json: any): CreatePrefilledEmailRequestDTO {
    return CreatePrefilledEmailRequestDTOFromJSONTyped(json, false);
}

export function CreatePrefilledEmailRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePrefilledEmailRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'cc': !exists(json, 'cc') ? undefined : json['cc'],
        'bcc': !exists(json, 'bcc') ? undefined : json['bcc'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'message': json['message'],
        'addMessage': !exists(json, 'add_message') ? undefined : json['add_message'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'isCustom': !exists(json, 'is_custom') ? undefined : json['is_custom'],
    };
}

export function CreatePrefilledEmailRequestDTOToJSON(value?: CreatePrefilledEmailRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'to': value.to,
        'cc': value.cc,
        'bcc': value.bcc,
        'subject': value.subject,
        'message': value.message,
        'add_message': value.addMessage,
        'priority': value.priority,
        'is_custom': value.isCustom,
    };
}

